module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"watchlist_floating_tooltip\">\n    <span class=\"tooltip\"></span>\n</div>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@e1ecef588b2f6e3fa0cc62c42be7a431d75a5eb4_fetch-_zjts3cyin5fcw45dgnvjsnodh4/node_modules/cbs-core-ui/src/js/templates/__watchlistFloatingTooltip.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"watchlist_floating_tooltip\">\n    <span class=\"tooltip\"></span>\n</div>\n")
    ; __line = 4
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@e1ecef588b2f6e3fa0cc62c42be7a431d75a5eb4_fetch-_zjts3cyin5fcw45dgnvjsnodh4/node_modules/cbs-core-ui/src/js/templates/__watchlistFloatingTooltip.tpl"

}